import { render, staticRenderFns } from "./homeSwiper.vue?vue&type=template&id=6280b223&scoped=true"
import script from "./homeSwiper.vue?vue&type=script&lang=js"
export * from "./homeSwiper.vue?vue&type=script&lang=js"
import style0 from "./homeSwiper.vue?vue&type=style&index=0&id=6280b223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280b223",
  null
  
)

export default component.exports